module.exports = __webpack_public_path__ + "img/Linkedin.14f08ad4.svg";